// extracted by mini-css-extract-plugin
module.exports = {"Results":"Results_Results__2iKBZ","Content":"Results_Content__2i24J","Measurements":"Results_Measurements__3u5QI"};